export default __webpack_public_path__ + "static/media/80.f45774d9.jpeg";